<template>
    <v-container fluid align-start ma-0 pa-2 class="container-height">
        <v-row no-gutters fill-height>
            <v-col cols="12">
                <i-card-vertical headerTitle="91.2 Fabrication Status">
                    <template v-slot:body>
                        <v-layout column overflow-auto>
                            <v-row dense>
                                <v-col cols="12" class="pa-0">
                                    <i-card-top class="d-md-flex" outlined :useBtnList="[
                                        'btnRetrieve', //Retrieve
                                        'btnExcel'
                                    ]" @btnRetrieve="btnRetrieve()"
                                       @btnExcel="onExporting()">
                                        <template v-slot:body>
                                            <v-layout column>
                                                <v-row no-gutters class="center pa-2 pb-0">
                                                    <v-icon small color="blue">mdi-circle</v-icon>
                                                    <span class="pa-1 subTitle"> Ship no : </span>
                                                    <v-col cols="2">
                                                        <v-select v-model="selectedShip" :items="shipNoList"
                                                            item-value="selectedShip" label="" return-object single-line
                                                            outlined dense @change="shipNoChange"></v-select>
                                                    </v-col>
                                                    <v-icon small color="blue" class="pl-2">mdi-circle</v-icon>
                                                    <span class="pa-1 subTitle"> Block : </span>
                                                    <v-col cols="1">
                                                        <v-select v-model="selectedBlock" :items="blockList" item-value="selectedBlock"  return-object single-line
                                                            outlined dense :label="'All'" @change="btnRetrieve()"></v-select>
                                                    </v-col>
                                                    <v-icon small color="blue" class="pl-2">mdi-circle</v-icon>
                                                    <span class="pa-1 subTitle">PSD From : </span>
                                                    <v-col cols="2">
                                                        <DxDateBox :value="startDate" height="30px" display-format="yyyy-MM-dd" :acceptCustomValue="false"
                                                            @value-changed="e => {reqDtFrom = e.value && getStrFormat(e.value)}" />
                                                    </v-col>
                                                    <span class="pa-1 subTitle"> ~ </span>
                                                    <v-col cols="2">
                                                        <DxDateBox :value="endDate" height="30px" display-format="yyyy-MM-dd" :acceptCustomValue="false"
                                                            @value-changed="e => {reqDtFrom = e.value && getEndFormat(e.value)}" />
                                                    </v-col>
                                                </v-row>
                                            </v-layout>
                                        </template>
                                    </i-card-top>
                                </v-col>
                            </v-row>
                            <v-row no-gutters>
                                <v-col cols="12" class="pa-0">                                    
                                    <DxDataGrid id="epms9064" class="listBox" :ref="epms9064Ref"
                                        :data-source="gridMainList" :remote-operations="false"
                                        :hover-state-enabled="true" :allow-column-resizing="true"
                                        :allow-column-reordering="true" :row-alternation-enabled="true"
                                        :show-borders="true" :width="grid.width" :show-row-lines="true" key-expr="id"
                                        :focused-row-enabled="true" :column-hiding-enabled="false"
                                        :selection="{ mode: 'none' }">
                                        <DxColumn data-field="no" caption="No" width="5%" data-type="string"
                                            :allow-editing="false" alignment="center" />
                                       
                                        <DxColumn data-field="matlSpec" caption="Material Spec" width="30%"
                                            data-type="string" :allow-editing="false" alignment="center" :visible="true"/>

                                        <DxColumn  caption="BOM" width="20%" data-type="string" :allow-editing="false"
                                            alignment="center" :visible="true" >
                                            <DxColumn data-field="partQty" caption="Qty" width="10%" data-type="number" format="#,###" :allow-editing="false"
                                                alignment="right" :visible="true" />
                                            <DxColumn data-field="partWgt" caption="Weight" width="10%" data-type="number" format="#,###" :allow-editing="false"
                                                alignment="right" :visible="true" />
                                        </DxColumn>

                                        <DxColumn caption="Not Make Start" width="20%" data-type="string" :allow-editing="false" alignment="center" :visible="true">
                                            <DxColumn data-field="nyQty" caption="Qty" width="10%" data-type="number" format="#,###" :allow-editing="false"
                                                alignment="right" :visible="true" />
                                            <DxColumn data-field="nyWgt" caption="Weight" width="10%" data-type="number" format="#,###" :allow-editing="false"
                                                alignment="right" :visible="true" />
                                        </DxColumn>

                                        <DxColumn caption="Make Start" width="20%" data-type="string" :allow-editing="false" alignment="center"
                                            :visible="true">
                                            <DxColumn data-field="ms" caption="Qty" width="10%" data-type="number" format="#,###" :allow-editing="false"
                                                alignment="right" :visible="true" />
                                            <DxColumn data-field="msWgt" caption="Weight" width="10%" data-type="number" format="#,###" :allow-editing="false"
                                                alignment="right" :visible="true" />
                                        </DxColumn>

                                        <DxColumn caption="Make Finish" width="20%" data-type="string" :allow-editing="false" alignment="center" :visible="true">
                                            <DxColumn data-field="mf" caption="Qty" width="10%" data-type="number" format="#,###" :allow-editing="false"
                                                alignment="right" :visible="true" />
                                            <DxColumn data-field="mfWgt" caption="Weight" width="10%" data-type="number" format="#,###" :allow-editing="false"
                                                alignment="right" :visible="true" />
                                        </DxColumn>

                                        <DxColumn caption="Paint Start" width="20%" data-type="string" :allow-editing="false" alignment="center"
                                            :visible="true">
                                            <DxColumn data-field="ps" caption="Qty" width="10%" data-type="number" format="#,###" :allow-editing="false"
                                                alignment="right" :visible="true" />
                                            <DxColumn data-field="psWgt" caption="Weight" width="10%" data-type="number" format="#,###" :allow-editing="false"
                                                alignment="right" :visible="true" />
                                        </DxColumn>

                                        <DxColumn caption="Paint Finish" width="20%" data-type="string" :allow-editing="false" alignment="center"
                                            :visible="true">
                                            <DxColumn data-field="pf" caption="Qty" width="10%" data-type="number" format="#,###" :allow-editing="false"
                                                alignment="right" :visible="true" />
                                            <DxColumn data-field="pfWgt" caption="Weight" width="10%" data-type="number" format="#,###" :allow-editing="false"
                                                alignment="right" :visible="true" />
                                        </DxColumn>

                                        <DxColumn caption="Delivery" width="20%" data-type="string" :allow-editing="false" alignment="center"
                                            :visible="true">
                                            <DxColumn data-field="delyQty" caption="Qty" width="10%" data-type="number" format="#,###" :allow-editing="false"
                                                alignment="right" :visible="true" />
                                            <DxColumn data-field="delyWgt" caption="Weight" width="10%" data-type="number" format="#,###" :allow-editing="false"
                                                alignment="right" :visible="true" />
                                        </DxColumn>

                                        <DxColumn caption="Warehouse" width="20%" data-type="string" :allow-editing="false" alignment="center" :visible="true">
                                            <DxColumn data-field="whQty" caption="Qty" width="10%" data-type="number" format="#,###" :allow-editing="false"
                                                alignment="right" :visible="true" />
                                            <DxColumn data-field="whWgt" caption="Weight" width="10%" data-type="number" format="#,###" :allow-editing="false"
                                                alignment="right" :visible="true" />
                                        </DxColumn>

                                        <DxPaging :enabled="true" :page-size="30" />
                                    </DxDataGrid>
                                </v-col>
                            </v-row>
                        </v-layout>
                    </template>
                </i-card-vertical>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>


import ICardVertical from '@/components/common/iCardVertical.vue'
import iCardTop from '@/components/common/iCardTop.vue'
import baseview from '@/components/base/baseview.vue' // 
import BaseDataGrid from '@/components/base/BaseDataGrid.vue'
import { getFabStatus } from '@/api/view/hip/91/epms9064.js'
import { getShipNoList1, epms9000_block } from '@/api/view/hip/common/common.js'
import { getDateFormat } from '@/utils/common.js'
import DxDateBox from 'devextreme-vue/date-box'
import { Workbook } from 'exceljs';
import { saveAs } from 'file-saver-es';
import { exportDataGrid } from 'devextreme/excel_exporter';
import { parseNumber } from 'devextreme/localization'
import { getNumComma } from '@/utils/common.js'

export default {
    name: 'epms9064',
    mixins: [baseview, BaseDataGrid],
    components: {
        ICardVertical,
        'i-card-top': iCardTop,
        DxDateBox
    },
    data() {
        return {
            gridMainList: [],
            epms9064Ref: "epms9064Ref",
            selectedShip: '',
            shipNoList: [],

            selectedBlock: 'All',
            blockList: [],

            startDate: '',
            endDate: '',

            stDte: '',
            edDte: ''
        }
    },
    computed: {
    gridMainInstance() {
      return this.GetDataGrid(this.epms9064Ref)
    },
  },
    methods: {
        getStrFormat(date) {
            this.stDte = getDateFormat(date)
            return getDateFormat(date)
        },
        getEndFormat(date) {
            this.edDte = getDateFormat(date)
            return getDateFormat(date)
        },
        shipNoChange(e) {                        
            this.blockList = [],
            
            this.getBlockList()
           
        },
        blockChange(e) {         
            //this.doSearchMain()
        },
        btnRetrieve() {
             if(!this.selectedShip) {
                this.vToastify(this.$t('Ship no is not selected.'), 'warn')
                return
            }

            this.doSearchMain()
        },
        async doSearchMain() {

            this.openLoading('searching')
            let params = {
                makerCd: this.$store.state.user.makerCd,
                shipNo: this.selectedShip, 
                block: this.selectedBlock === 'All' ? '' : this.selectedBlock,
                stDte: this.stDte,
                fiDte: this.edDte
            }

            await getFabStatus(params).then(res => {
                this.gridMainList = res.list

            }).finally(() => {
                //console.log(this.gridMainList);
                this.endLoading();
            })
        },

        async getShipNoList() {
            let params = {
                makerCd: this.$store.state.user.makerCd
            }

            await getShipNoList1(params).then(res => {
                res.list.forEach(e => {
                    this.shipNoList.push(e.shipNo)
                });
            })
        },

        async getBlockList() {
            let params = {
                incNotPo: 'Y',
                makerCd: this.$store.state.user.makerCd,
                shipNo: this.selectedShip
            }

            await epms9000_block(params).then(res => {
                this.blockList.push('All')
                res.list.forEach(e => {
                    this.blockList.push(e.block)
                });
            })
        },

        onExporting(e) {
            const workbook = new Workbook();
            const worksheet = workbook.addWorksheet('Fabrication Status');

            exportDataGrid({
                component: this.gridMainInstance,
                worksheet,
                topLeftCell: { row: 1, column: 1 },
            }).then((cellRange) => {
                const headerRow = worksheet.getRow(1);
                const headerStyle = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'DFE3D5' } }
                const headerBorderStyle = { left: { style: 'thin', fgColor: { argb: 'bfbfbf' } }, right: { style: 'thin', fgColor: { argb: 'bfbfbf' } }, bottom: { style: 'thin', fgColor: { argb: 'bfbfbf' } } }
                let headerRowLength = headerRow._cells.length
                for (let i = 1; i <= headerRowLength; i++) {
                    headerRow.getCell(i).fill = headerStyle
                    headerRow.getCell(i).border = headerBorderStyle
                    headerRow.getCell(i).alignment = { horizontal: 'center' }
                }
                for (let j = 2; j <= worksheet._rows.length; j++) {
                    for (let a = 1; a <= worksheet.getRow(j)._cells.length; a++) {
                        worksheet.getRow(j).getCell(a).border = headerBorderStyle
                    }
                }
            }).then(() => {
                workbook.xlsx.writeBuffer().then((buffer) => {
                    saveAs(new Blob([buffer], { type: 'application/octet-stream' }), 'FabricationStatus.xlsx');
                });
            });
            this.gridMainInstance.cancel = true;
        }

        // uppercase() {
        //     this.pntCd = this.pntCd.toUpperCase();
        // }
    },
    mounted() {
        var date = new Date();
        this.startDate = new Date(date.getFullYear(), 0, 1)
        this.endDate = new Date(date.getFullYear(), date.getMonth() + 2, 0);
        this.getShipNoList()
    }
}
</script>

<style>

</style>